var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tiptap-btn",class:{ 'is-active': _vm.editor.isActive('orderedList') },attrs:{"type":"button","title":_vm.$t('Numbered list'),"disabled":_vm.disabled},on:{"click":function($event){_vm.editor.chain().focus().toggleOrderedList().run()}}},[_c('FormatListNumberedIcon',{attrs:{"size":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }